import Signal from 'libs/signals';

const edoProgramRequestsSignal = Signal({
  programRequests: [],
  selectedProgramRequest: {
    id: null,
    dateSubmitted: '',
    program: null,
    applicationId: null,
    lenderName: '',
    contactName: '',
    allocationAsk: '',
    approvedAmount: '',
    status: '',
    note: [],
    applicationUpdatedDate: '',
    updatedDate: '',
    documents: [],
  },
  modalVisible: false,
  isPaginating: false,
  updateApplicationStatus: '',
  bundle: {},
});

export default edoProgramRequestsSignal;

export const edoProgramRequestApplicationDocumentTypesSignal = Signal([]); // need
export const edoProgramRequestApplicationsNoteSignal = Signal(''); // need
export const edoProgramRequestFilterSignal = Signal({
  filter: '',
  enableApplyButton: false,
});
export const edoProgramRequestCursor = Signal(null);
